import _ from "lodash";

const createQuery = (defaultArguments = {}, queryArguments = {}) => {
    if (typeof defaultArguments !== "object" || typeof queryArguments !== "object") {
        return "";
    }
    queryArguments = _.merge(defaultArguments, queryArguments);
    return Object.keys(queryArguments)
        .map(key => `${key}=${queryArguments[key]}`)
        .join("&");
};

export default createQuery;



// WEBPACK FOOTER //
// ./src/helpers/create-query.js